const BIN_PREFIX_TO_BANK_TR = {
  479227: "Garanti BBVA",
  426886: "Garanti BBVA",
  413729: "Garanti BBVA",
  540061: "Türkiye İş Bankası",
  540668: "Türkiye İş Bankası",
  552879: "Akbank",
  552608: "Akbank",
  589004: "Ziraat Bankası",
  516843: "Ziraat Bankası",
  516846: "Ziraat Bankası",
  516840: "Ziraat Bankası",
  521807: "VakıfBank",
  493846: "VakıfBank",
  545847: "QNB Finansbank",
  979212: "Troy",
  979206: "Troy",
  650170: "Troy",
  650082: "Troy",
  403998: "Yapı Kredi",
  545616: "Yapı Kredi",
  552143: "Halkbank",
  453144: "Halkbank",
  554960: "DenizBank",
  516731: "TEB",
  552679: "ING",
};

/**
 * minimum 6 digits, match 6→4 digits.
 * @returns {string|null}
 */
export function guessBankFromPan(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length < 6) {
    return null;
  }
  for (let len = 6; len >= 4; len -= 1) {
    const prefix = d.slice(0, len);
    if (BIN_PREFIX_TO_BANK_TR[prefix]) {
      return BIN_PREFIX_TO_BANK_TR[prefix];
    }
  }
  return null;
}

/**
 * detect card brand from PAN (only client side for UI; reference final backend logic).
 * @returns {'visa'|'mastercard'|'amex'|'troy'|'discover'|null}
 */
export function detectCardBrandFromPan(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length < 1) {
    return null;
  }
  if (
    d.startsWith("9792") ||
    d.startsWith("650170") ||
    d.startsWith("650082")
  ) {
    return "troy";
  }
  if (d[0] === "4") {
    return "visa";
  }
  if (d.startsWith("34") || d.startsWith("37")) {
    return "amex";
  }
  if (d[0] === "9") {
    return "troy";
  }
  if (
    d.startsWith("6011") ||
    (d.startsWith("65") && !d.startsWith("650170") && !d.startsWith("650082"))
  ) {
    return "discover";
  }
  if (d[0] === "5") {
    return "mastercard";
  }
  if (d[0] === "2") {
    if (d.length >= 4) {
      const n4 = parseInt(d.slice(0, 4), 10);
      if (n4 >= 2221 && n4 <= 2720) {
        return "mastercard";
      }
    }
    if (d.length >= 2) {
      return "mastercard";
    }
  }
  return null;
}

/** if mask param still starts with TROY BIN (even when KK_Tip = Mastercard) */
export function maskBinSuggestsTroy(maskBin) {
  const d = String(maskBin || "").replace(/\D/g, "");
  if (d.length < 6) {
    return false;
  }
  return (
    d.startsWith("9792") || d.startsWith("650170") || d.startsWith("650082")
  );
}

/**
 * normalize card_brand string from API to icon key
 * @returns {'visa'|'mastercard'|'amex'|'troy'|'discover'|null}
 */
export function normalizeCardBrandKey(brand) {
  if (!brand || typeof brand !== "string") {
    return null;
  }
  const s = brand.trim().toLowerCase();
  if (s.includes("visa")) {
    return "visa";
  }
  if (s.includes("master")) {
    return "mastercard";
  }
  if (s.includes("american") || s.includes("amex")) {
    return "amex";
  }
  if (s.includes("troy")) {
    return "troy";
  }
  if (s.includes("discover")) {
    return "discover";
  }
  return null;
}
